import React from 'react';

const OpenLinkIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.1413 10.8187L16.75 3.33334M16.75 3.33334V7.61106M16.75 3.33334H12.4022M10.9076 6.32247H4.72554C4.59942 6.32247 4.47847 6.37258 4.38928 6.46176C4.3001 6.55094 4.25 6.6719 4.25 6.79802V15.3578C4.25 15.4839 4.3001 15.6049 4.38928 15.6941C4.47847 15.7832 4.59942 15.8333 4.72554 15.8333H13.2853C13.4114 15.8333 13.5324 15.7832 13.6216 15.6941C13.7108 15.6049 13.7609 15.4839 13.7609 15.3578V9.17573",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
OpenLinkIcon.displayName = "Icons.OpenLinkIcon";

export { OpenLinkIcon };
//# sourceMappingURL=OpenLinkIcon.js.map
